export const isGridDataChangedInfo = (value) => {
    return typeof value.rowTrigger === 'string';
};
export const isCellDataChangedInfo = (value) => {
    return !isGridDataChangedInfo(value);
};
